<template>
  <div style="margin: 0px 30px; margin-top: 30px" class="report-5" dir="rtl">
    <!-- <div style="margin-top: 200px;" v-if="pathLogo == m "></div> -->
    <div v-for="(items, i) in allData" :key="i" class="report-5" dir="rtl">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header
              style="margin-bottom: 30px"
              class="md-card-header-text md-card-header-green"
            >
              <div class="card-text">
                <!-- <h4 class="title">صرف الرواتب عن الشهر <span style="margin-right: 10px;">{{ theMonth }}</span> -->
                <h4 class="title">المصرف : {{ items.bankBranch }}</h4>
              </div>
            </md-card-header>
            <div class="md-layout-item md-size-100">
              <h4 class="text-center">
                <span style="font-weight: bold">{{ items.fullName }}</span>
              </h4>
              <h4 class="text-center">{{ items.shortName }}</h4>
              <h3 class="text-center">تقرير صرف الرواتب عن الشهر</h3>
            </div>
            <div style="margin-right: 40px; margin-bottom: 50px" class="four">
              <h4>نموذج م ح / 13</h4>
              <h4>إستمارة رقم :</h4>
            </div>

            <div style="margin-tob: 30px; margin-right: 20px" class="md-layout">
              <div class="md-layout-item md-size-30 ml-15">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>المصرف</label>
                  <md-input disabled v-model="items.bankBranch"></md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-size-30 ml-15">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>نوع المعاملة </label>
                  <md-input disabled v-model="type"></md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-size-30 ml-15">
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label> تاريخ الطباعة </label>
                  <md-input disabled v-model="date"></md-input>
                </md-field>
              </div>

              <div
                style="margin-top: 30px"
                class="md-layout-item md-size-30 ml-15"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <label>إستمارة صرف رواتب عن شهر </label>
                  <md-input disabled v-model="month"></md-input>
                </md-field>
              </div>
            </div>

            <div
              style="margin-top: 10px; margin-bottom: 35px"
              class="marginTop"
            >
              <md-card-content>
                <md-table
                  class="paginated-table table-striped table-hover mt-25"
                >
                  <md-table-row>
                    <md-table-cell>ر.م</md-table-cell>

                    <md-table-cell class="w-200">الإسم</md-table-cell>

                    <md-table-cell class="w-100">رقم الحساب</md-table-cell>

                    <md-table-cell class="w-100">الرقم المالي</md-table-cell>

                    <md-table-cell class="w-100">ر.م المالية</md-table-cell>

                    <md-table-cell class="w-100">الدرجة</md-table-cell>

                    <md-table-cell class="w-100">شهر العلاوة</md-table-cell>

                    <md-table-cell class="w-100">الأساسى</md-table-cell>

                    <md-table-cell class="w-100">ندب</md-table-cell>

                    <md-table-cell class="w-100">مكأفاءة</md-table-cell>

                    <md-table-cell class="w-100">الإجمالى</md-table-cell>

                    <md-table-cell class="w-100">ضمان</md-table-cell>

                    <md-table-cell class="w-100">الدخل</md-table-cell>

                    <md-table-cell class="w-100">الجهاد</md-table-cell>

                    <md-table-cell class="w-100">الدمغة</md-table-cell>

                    <md-table-cell class="w-100">تضامن</md-table-cell>

                    <md-table-cell class="w-100">نفقة شرعية</md-table-cell>

                    <md-table-cell class="w-100">ق.سلفة</md-table-cell>

                    <md-table-cell class="w-100">خصم أخرى</md-table-cell>

                    <md-table-cell class="w-100">خ.عقوبة</md-table-cell>

                    <md-table-cell class="w-100">خ. غياب</md-table-cell>

                    <md-table-cell class="w-100">علاوة بالصافى</md-table-cell>

                    <md-table-cell class="w-100">خصميات</md-table-cell>

                    <md-table-cell class="w-100">علاوة لجنة</md-table-cell>

                    <md-table-cell
                      class="w-100"
                      v-for="(item, i) in items.items[0].allowances"
                      :key="i"
                    >
                      {{ item.key }}
                    </md-table-cell>

                    <md-table-cell class="w-100">العمل الاضافى</md-table-cell>

                    <md-table-cell class="w-100">صافى المرتبات</md-table-cell>

                    <md-table-cell class="w-100">الرقم الوطنى</md-table-cell>
                  </md-table-row>
                  <md-table-row v-for="(item, i) in items.items" :key="i">
                    <md-table-cell md-label="الصنف">{{ i + 1 }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.employeeName
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.accountNumber
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.financialNumber
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.fileNumber
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.degree
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      convert_Month(item.bonusDueDate)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.basicSalary)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">0</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.rewards)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.totalSalary)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.warrantyTax)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">0</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.jihadTax)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.stampTax)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.solidarityTax)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.legalExpenseDiscount)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.creditDiscount)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.otherDiscounts)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">0</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.absanceDiscount)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.totalAllowance)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.totalDiscount)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.committeesAllownace)
                    }}</md-table-cell>

                    <md-table-cell
                      md-label="الصنف"
                      v-for="(item, i) in items.items[0].allowances"
                      :key="i"
                    >
                      {{ item.value }}
                    </md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.overTime)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      formatValues(item.netSalary)
                    }}</md-table-cell>

                    <md-table-cell md-label="الصنف">{{
                      item.nationalNumber
                    }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </div>
          </md-card>
        </div>
      </div>
    </div>

    <section style="margin-right: 18px; margin-left: 18px" class="final-footer">
      <p>رئيس قسم الحسابات</p>
      <p>المراجعة الداخلية</p>
      <p>المراقب المالى</p>
    </section>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: {
    pathLogo: String,
    date: String,
    start: String,
    finish: String,
    name: String,
    desc: String,
    month: String,
    theMonth: String,
    allData: [],
    pdf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      type: "مرتبات الموظفين",
      m: env.mTop(),
    };
  },
  methods: {
    formatValues(value) {
      if (value) {
        return value.toLocaleString();
      }
      return value;
    },
    convert_Month(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getMonth() + 1;
      } catch (error) {}
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/report-5";
</style>
